(() => {
  window.addEventListener("abra:popup:shown", () => {
    const abraPopupContent = document.querySelector(
      "abra-popup .abra-popup__text"
    );

    if (abraPopupContent && abraPopupContent.innerText) {
      const decodedContent = decodeHTMLEntities(abraPopupContent.innerText);

      if (/<a\s+href=["'](.*?)["']>(.*?)<\/a>/gi.test(decodedContent)) {
        abraPopupContent.style.visibility = "hidden";

        const safeContent = sanitizeAndRenderLinks(decodedContent);

        abraPopupContent.innerHTML = safeContent;

        abraPopupContent.style.visibility = "visible";
      }
    }
  });

  function decodeHTMLEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  function sanitizeAndRenderLinks(input) {
    const linkRegex = /<a\s+href=["'](.*?)["']>(.*?)<\/a>/gi;
    const container = document.createElement("div");

    let lastIndex = 0;
    let result = "";

    input.replace(linkRegex, (match, href, text, offset) => {
      result += document.createTextNode(
        input.slice(lastIndex, offset)
      ).textContent;

      const a = document.createElement("a");
      a.href = href;
      a.textContent = text;
      a.target = "_self";
      a.rel = "noopener noreferrer";

      const tempDiv = document.createElement("div");
      tempDiv.appendChild(a);
      result += tempDiv.innerHTML;

      lastIndex = offset + match.length;
    });

    result += document.createTextNode(input.slice(lastIndex)).textContent;

    return result;
  }
})();

(() => {
  const addOneTimeBadge = () => {
    const oneTimeLabel = document.querySelector('.skio-plan-picker label[for*="skio-one-time"]');
    if (!oneTimeLabel || oneTimeLabel.querySelector('.skio-save-onetime')) return;
    
    const topline = oneTimeLabel.querySelector('.skio-group-topline');
    const priceDiv = topline?.querySelector('.skio-price');
    if (!topline || !priceDiv) return;
    
    const badge = document.createElement('span');
    badge.className = 'skio-save skio-save-onetime';
    badge.style.display = 'none';
    badge.innerHTML = 'Save <span skio-onetime-discount></span>';
    
    topline.insertBefore(badge, priceDiv);
  };

  addOneTimeBadge();
  setTimeout(addOneTimeBadge, 100);
  setTimeout(addOneTimeBadge, 500);
})();

(() => {
  let debounceTimer;
  let lastSelectedPlan = null;

  const initAbra = () => {
    if (!window.Abra) return;
    window.Abra.useSellingPlanPriceOnProductBlock = true;
    window.Abra.render();
  };

  const checkPlanChange = () => {
    const checkedInput = document.querySelector('[skio-plan-picker] input:checked');
    if (!checkedInput) return;

    const currentPlan = checkedInput.id || checkedInput.value;
    if (currentPlan !== lastSelectedPlan) {
      lastSelectedPlan = currentPlan;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(initAbra, 100);
    }
  };

  const observeSkio = () => {
    const skioBlock = document.querySelector('[skio-plan-picker]');
    if (!skioBlock) return;

    skioBlock.addEventListener('change', checkPlanChange);
    skioBlock.addEventListener('click', () => {
      setTimeout(checkPlanChange, 50);
    });

    const checkedInput = skioBlock.querySelector('input:checked');
    if (checkedInput) {
      lastSelectedPlan = checkedInput.id || checkedInput.value;
    }
    
    initAbra();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSkio);
  } else {
    observeSkio();
  }

  setTimeout(initAbra, 1000);
})();
